import { __assign } from 'tslib';
import * as React from 'react';

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 123.103"
  }, props), React.createElement("path", {
    transform: "translate(0 1)",
    style: {
      fill: "none"
    },
    d: "M0 0h120v120H0z"
  }), React.createElement("path", {
    d: "M78.767 50.339a5.231 5.231 0 0 0 1.4-3.834l-.244-10.863a5.457 5.457 0 0 0-1.723-4.054 5.694 5.694 0 0 0-3.9-1.575l-23.362-.524-.6-23.44a5.319 5.319 0 0 0-1.575-3.9A5.206 5.206 0 0 0 44.78.5L33.916.253a4.885 4.885 0 0 0-3.836 1.4 4.944 4.944 0 0 0-1.473 3.908L29.059 29l-23.507-.38a5.056 5.056 0 0 0-3.836 1.4 4.939 4.939 0 0 0-1.474 3.907l.316 10.791A5.019 5.019 0 0 0 2.209 48.7a4.6 4.6 0 0 0 3.9 1.575l23.438.6.527 23.51a4.943 4.943 0 0 0 1.575 3.9C32.87 79.5 34 80.2 35.63 79.935l10.789.316a5.715 5.715 0 0 0 3.908-1.474 5.223 5.223 0 0 0 1.4-3.836l-.305-23.579 23.51.528a5.156 5.156 0 0 0 3.835-1.551Z",
    transform: "rotate(45 18.526 77.71)",
    style: {
      fill: "rgba(0,0,0,.3)"
    }
  }), React.createElement("path", {
    d: "M78.767 50.339a5.231 5.231 0 0 0 1.4-3.834l-.244-10.863a5.457 5.457 0 0 0-1.723-4.054 5.694 5.694 0 0 0-3.9-1.575l-23.362-.524-.6-23.44a5.319 5.319 0 0 0-1.575-3.9A5.206 5.206 0 0 0 44.78.5L33.916.253a4.885 4.885 0 0 0-3.836 1.4 4.944 4.944 0 0 0-1.473 3.908L29.059 29l-23.507-.38a5.056 5.056 0 0 0-3.836 1.4 4.939 4.939 0 0 0-1.474 3.907l.316 10.791A5.019 5.019 0 0 0 2.209 48.7a4.6 4.6 0 0 0 3.9 1.575l23.438.6.527 23.51a4.943 4.943 0 0 0 1.575 3.9C32.87 79.5 34 80.2 35.63 79.935l10.789.316a5.715 5.715 0 0 0 3.908-1.474 5.223 5.223 0 0 0 1.4-3.836l-.305-23.579 23.51.528a5.156 5.156 0 0 0 3.835-1.551Z",
    transform: "rotate(45 23.354 75.71)",
    style: {
      fill: "#afafaf"
    }
  }), React.createElement("path", {
    d: "M78.767 50.339a5.231 5.231 0 0 0 1.4-3.834l-.244-10.863a5.457 5.457 0 0 0-1.723-4.054 5.693 5.693 0 0 0-3.9-1.575l-23.362-.524-.6-23.44a5.319 5.319 0 0 0-1.575-3.9A5.206 5.206 0 0 0 44.78.5L33.916.253a4.884 4.884 0 0 0-3.836 1.4 4.943 4.943 0 0 0-1.473 3.908L29.059 29l-23.507-.38a5.054 5.054 0 0 0-3.836 1.4 4.94 4.94 0 0 0-1.474 3.907l.316 10.791A5.021 5.021 0 0 0 2.209 48.7a4.6 4.6 0 0 0 3.9 1.575l23.438.6.527 23.51a4.943 4.943 0 0 0 1.575 3.9C32.87 79.5 34 80.2 35.631 79.935l10.788.316a5.715 5.715 0 0 0 3.908-1.474 5.224 5.224 0 0 0 1.4-3.836l-.306-23.579 23.51.528a5.157 5.157 0 0 0 3.836-1.551Z",
    transform: "rotate(45 30.597 72.71)",
    style: {
      fill: "#fff"
    }
  }));
};

export { SvgClose as default };